// 普通箱线图: 按照group列进行分组填色
import ChartTemplate from '../ChartTemplate';

export default {
  extends: ChartTemplate,
  data () {
    return { srcSeries: null }
  },
  methods: {
    initOptionAfter () {
      this.srcSeries = this.chartOption.series;
      this.Utility.deepMerge(this.chartOption, { chart: { events: { render: this.processBoxColor } } })
    },
    initChartAfter () {
      this.processColor(this.Highcharts.getOptions().colors);
    },
    onParamFormChangedBefore (e, item) {
      if (item.code === 'colors') {
        this.processColor(e.split(','));
        return false;
      }
    },
    // =================== 处理每组箱体颜色
    processColor (cs) {
      let series = this.Utility.clone(this.srcSeries);
      let tcs = [];
      for (let i = 0; i < 10; i++) tcs.push(...cs);
      let boxData = series[0].data, scatterData = series[1].data, groupColor = {}, colorIndex = 0;
      for (let i = 0; i < boxData.length; i++) {
        let g = boxData[i].group;
        if (!groupColor[g]) groupColor[g] = tcs[colorIndex++];
        boxData[i].color = groupColor[g];
        let sd = scatterData.filter(sd => sd.x == i);
        if (sd) sd.forEach(s => s.color = groupColor[g]);
      }
      this.chart.update({ series: series });
    },
    // ================== 处理箱体颜色
    processBoxColor () {
      let a = document.getElementById(this.chartElId);
      let b = a.getElementsByClassName('highcharts-point');
      if (b && b.length) {
        b.forEach(item => {
          let c = item.getElementsByClassName('highcharts-boxplot-box');
          if (c && c.length) {
            let color = c[0].getAttribute('stroke');
            c[0].setAttribute('fill', color + '99');
          }
        })
      }
    }
  }
}